import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import RenderStatus from "../../../styles/styledStatus";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { Tooltip } from "@material-ui/core";
import Notification from "../../../elements/notification/Notification";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { useTranslation } from "react-i18next";

import { StyledTooltip } from "../../../styles/styledTooltip";
import { StyledCopy } from "../../../styles/styledCopy";
import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const PaymentList = ({ payments }) => {
  const { t } = useTranslation("paymentsPage");

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  if (!payments) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (payments.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledScrollTable className="transactions_scroll">
        <StyledTable
          width="3200"
          size="14"
          className="payment-table transactions-table"
        >
          <StyledTableHead
            scroll="auto"
            className="payment-table__head transactions-table__head"
          >
            <div>
              Id
              <Tooltip
                title={t("table.tooltips.id")}
                arrow
                placement="top"
              >
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              Reference id
              <Tooltip
                title={t("table.tooltips.referenceId")}
                arrow
                placement="top"
              >
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              {t("table.project")}
            </div>
            <div>
              {t("table.service")}
            </div>
            <div>
              {t("table.paymentSystem")}
            </div>
            <div>
              {t("table.currency")}
            </div>
            <div>
              {t("table.amount")}
              <Tooltip
                title={t("table.tooltips.amount")}
                arrow
                placement="top"
              >
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              {t("table.processedAmount")}
              <Tooltip
                title={t("table.tooltips.processedAmount")}
                arrow
                placement="top"
              >
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              {t("table.status")}
            </div>
            <div>
              {t("table.profit")}
            </div>
            <div>
              {t("table.rateProfit")}
            </div>
            <div>
              {t("table.createdAt")}
            </div>
            <div>
              {t("table.updatedAt")}
            </div>
            <div>
              {t("table.paymentType")}
            </div>
            <div>
              {t("table.transactionType")}
            </div>
            <div>
              Related reference id
            </div>
            <div>
              {t("table.note")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {payments && payments.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="12"
                className="payment-table__row transactions-table__row"
                onClick={(e) => {showDetails(e)}}
                cursor="pointer"
                as={NavLink}
                to={`/payments/${value.id}`}
              >
                <StyledCol inline data-title="id">
                  <CopyToClipboard
                    className="stop-event"
                    text={value.id}
                    onCopy={() => {
                      setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
                    }}
                  >
                    <StyledBreakWord as="p">
                      {value.id} <StyledCopy title={t("table.copy")}   className="icon-light-copy" />
                    </StyledBreakWord>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol inline data-title="Reference id">
                  <CopyToClipboard
                    className="stop-event"
                    text={value.referenceId}
                    onCopy={() => {
                      setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
                    }}
                  >
                    <StyledBreakWord as="p">
                      {value.referenceId} <StyledCopy title={t("table.copy")}  className="icon-light-copy" />
                    </StyledBreakWord>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol data-title={t("table.project")}>
                  {value.connection.project.name}
                </StyledCol>
                <StyledCol data-title={t("table.service")}>
                  {getServiceNameWithNickname(value.connection.service.name, value.connection.service.nickname)}
                </StyledCol>
                <StyledCol data-title={t("table.paymentSystem")}>
                  {value.paymentSystem.name}
                </StyledCol>
                <StyledCol data-title={t("table.currency")}>
                  {value.currency.asset}
                </StyledCol>
                <StyledCol data-title={t("table.amount")}>
                  {value.amount}
                </StyledCol>
                <StyledCol data-title={t("table.processedAmount")}>
                  {value.processedAmount}
                </StyledCol>
                <StyledCol inline data-title={t("table.status")}>
                  <RenderStatus status={value.status.value} />
                </StyledCol>
                <StyledCol data-title={t("table.profit")}>
                  {value.profit}
                </StyledCol>
                <StyledCol data-title={t("table.rateProfit")}>
                  {value.rateProfit}
                </StyledCol>
                <StyledCol data-title={t("table.createdAt")}>
                  {TimestampToDateMoment(value.createdAt)}
                </StyledCol>
                <StyledCol data-title={t("table.updatedAt")}>
                  {TimestampToDateMoment(value.updatedAt)}
                </StyledCol>
                <StyledCol data-title={t("transactions.table.paymentType")}>
                  {value.paymentType}
                </StyledCol>
                <StyledCol data-title={t("transactions.table.transactionType")}>
                  {value.transactionType}
                </StyledCol>
                <StyledCol data-title="Related reference id">
                  {value.relatedReferenceId ?
                    <CopyToClipboard
                      className="stop-event"
                      text={value.relatedReferenceId}
                      onCopy={() => {
                        setNotification({
                          ...notification,
                          visible: true,
                          type: "success",
                          message: t("transactions.table.copied")
                        });
                      }}
                    >
                      <StyledBreakWord as="p">
                        {value.relatedReferenceId} <StyledCopy
                        title={t("transactions.table.copy")}
                        className="icon-light-copy"
                      />
                      </StyledBreakWord>
                    </CopyToClipboard>
                    : "--"}
                </StyledCol>
                <StyledCol inline data-title={t("table.note")} className="transactions-table__note">
                  <p className="note">
                    {value.note}
                  </p>
                  {value.note && value.note.length > 25 &&
                  <Tooltip
                    title={value.note}
                    arrow
                    placement="top"
                  >
                    <StyledTooltip className="icon-light-info" />
                  </Tooltip>}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default PaymentList;